import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import createScript from '../../../../utils/create-script'
import { useSelector } from 'react-redux'
import { afterpay_cash_app_checkout, afterpay_cash_app_callback, billingCheckout, billingPlaceOrder } from '../../../../../api'
import { useQuery } from '../../../../hooks/common'
import Paying from '../../pages/credit-pay/components/loading/paying'
import { BigButton } from '../../../../components/button'

export default props => {

    const { onError, country, orderTotal, payMethod, inputOrder, shoudBilling, clickHandle, isFastPayment, check } = props

    const global = useSelector(state => state.global)
    const { config } = global
    const isSandBox = config?.env === 'sandbox'
    const [cashEvent, setCashEvent] = useState(null)
    const query = useQuery()
    const { isCashApp, isRedirected, cash_request_id, transactionId } = query
    const [paying, setPaying] = useState(isCashApp)

    useEffect(async () => {
        if (isCashApp, isRedirected, cash_request_id) {
            await createScript('afterpay-wedgit-script', isSandBox ? 'https://portal.sandbox.afterpay.com/afterpay-async.js' : 'https://portal.afterpay.com/afterpay-async.js')
            const cashAppPayListenerOptions = {
                onComplete: async event => {
                    const { status, cashtag, orderToken } = event.data
                    const response = await afterpay_cash_app_callback({ status, cashtag, token: orderToken, transactionId, payMethod })
                    if(response?.code === 200 && response?.result && response.result.success){
                        window.location.href = `/order-confirm/${transactionId}`
                    }else{
                        onError({message: response?.result?.details || response?.result || 'Network Error'})
                        setPaying(false)
                    }
                    console.log(event)
                },
                eventListeners: {
                    "CUSTOMER_INTERACTION": ({ isMobile }) => {
                        console.log(`CUSTOMER_INTERACTION`)
                        if (isMobile) {
                            // captureMobileMetrics()
                        } else {
                            // captureDesktopMetrics()
                        }
                    },
                    "CUSTOMER_REQUEST_DECLINED": event => {
                        setPaying(false)
                        onError({message: 'The transaction was declined, please try again.'})
                    },
                    "CUSTOMER_REQUEST_APPROVED": event => {
                        console.log(`CUSTOMER_REQUEST_APPROVED`)
                    },
                    "CUSTOMER_REQUEST_FAILED": event => {
                        setPaying(false)
                        onError({message: 'Network Error, please try again.'})
                        console.log(`CUSTOMER_REQUEST_FAILED`)
                    }
                }
            }

            window.AfterPay.initializeCashAppPayListeners({ countryCode: country, cashAppPayListenerOptions });
        }
    }, [])

    const renderCashAppPay = () => {
        return new Promise((resolve, reject) => {
            window.AfterPay.renderCashAppPayButton({
                countryCode: country,
                cashAppPayButtonOptions: {
                    button: false,
                    manage: false,
                    onBegin: (e) => {
                        resolve(e)
                    }
                }
            })
        })
    }

    const cashClickHandle = async e => {
        try {
            clickHandle?.()
            if(check){
                if(!check()){
                    return false
                }
            }
        } catch (error) {
            
        }

        setPaying(true)
        let orderResponse
        if (inputOrder) {
            orderResponse = {
                result: inputOrder,
                code: 200
            }
        } else {

            if (shoudBilling) {
                await billingCheckout()
            }

            orderResponse = await billingPlaceOrder(isFastPayment)
        }

        if (orderResponse?.code === 200 && orderResponse?.result) {
            const order = orderResponse?.result
            const [a, response] = await Promise.all([
                createScript('afterpay-wedgit-script', isSandBox ? 'https://portal.sandbox.afterpay.com/afterpay.js' : 'https://portal.afterpay.com/afterpay.js'),
                afterpay_cash_app_checkout({ payMethod, orderId: order.id })
            ])

            if (response?.code === 200 && response?.result) {

                window.AfterPay.restartCashAppPay()

                const { begin, destroy } = await renderCashAppPay()
                var cashAppPayOptions = {
                    redirectUrl: window.location.href, // where mobile customers should be redirected to
                    onComplete: function (event) {
                        const { status, cashtag } = event.data
                    },
                }
                window.AfterPay.initializeForCashAppPay({ countryCode: country, token: response.result.token, cashAppPayOptions })

                // setTimeout(() => {
                    begin()
                // }, 5000)

            }
        }
    }

    return <>
        <BigButton loading={paying} className={props.className} onClick={cashClickHandle} style={{ cursor: 'pointer' }}>
            {props.content}
        </BigButton>
        <span id="cash-app-pay"/>
        {
            paying && isCashApp && typeof window !== 'undefined' && ReactDOM.createPortal(<Paying />, document.getElementById('root'))
        }
    </>

}